import { render, staticRenderFns } from "./TeamNews.vue?vue&type=template&id=af374f3c&scoped=true"
import script from "./TeamNews.vue?vue&type=script&lang=js"
export * from "./TeamNews.vue?vue&type=script&lang=js"
import style0 from "./TeamNews.vue?vue&type=style&index=0&id=af374f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af374f3c",
  null
  
)

export default component.exports